import React from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { useTranslation } from 'i18n';
import useAuthProps from 'hooks/useAuthProps';
import useLoggedOutFavoriteEvent from 'hooks/useLoggedOutFavoriteEvent';
import UserEventCard from 'components/common/EventCard/UserEventCard';

export interface IProps {
  top?: React.ReactNode;
  events: any[];
  isEventsFetching: boolean;
  hasFilters?: boolean;
  onToggleFavoriteEvent: (id: number) => void;
}

const EventsList: React.FC<React.PropsWithChildren<IProps>> = ({
  top,
  events,
  hasFilters,
  isEventsFetching,
  onToggleFavoriteEvent,
}) => {
  const [t] = useTranslation('public');
  const { isAuthenticated, onLogin } = useAuthProps();
  const { loggedOutFavoriteEvent, setLoggedOutFavoriteEvent, handleResetLoggedOutFavoriteEvent } =
    useLoggedOutFavoriteEvent();

  return (
    <Grid container>
      {top && (
        <Grid item xs={12} sx={{ mb: 5 }}>
          {top}
        </Grid>
      )}
      {events.length !== 0 && (
        <Grid item xs={12}>
          <Grid container spacing={8}>
            {events.map((event: any) => (
              <Grid item xs={12} md={4} key={event.id}>
                <UserEventCard
                  event={event}
                  isFavoriteOfflineToggled={loggedOutFavoriteEvent === event.id}
                  onLogin={onLogin}
                  onToggleFavorite={isAuthenticated ? onToggleFavoriteEvent : setLoggedOutFavoriteEvent}
                  onCloseFavoritePopUp={handleResetLoggedOutFavoriteEvent}
                  showLocation
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
      {isEventsFetching && (
        <Grid item xs={12} container justifyContent="center">
          <CircularProgress />
        </Grid>
      )}
      {events.length === 0 && !isEventsFetching && (
        <Grid item xs={12}>
          <Typography align="center" variant="h4" paragraph>
            {t<string>('common:statement.noResultFound')}
          </Typography>
          {hasFilters && (
            <Typography align="center" variant="h6" color="primary">
              {t<string>('common:statement.pickAnotherFilter')}
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default EventsList;
